export const numeralLocaleConfigDE = {
    delimiters: {
        thousands: ' ',
        decimal: ',',
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't',
    },
    ordinal: (num) => {
        return '.';
    },
    currency: {
        symbol: '€',
    },
};
